// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames not based on template
	if (chunkId === 474) return "static/chunks/225f8dbd-400247a556cd2041.js";
	if (chunkId === 875) return "static/chunks/875-4b7b63fd275b8cce.js";
	// return url for filenames based on template
	return "static/chunks/" + chunkId + "." + {"256":"94f1f583dba3bfa4","270":"c265ad163ebdf9f7","460":"5a2fed1ea2828c94","608":"14504e772dcdce70"}[chunkId] + ".js";
};